module.exports = __webpack_public_path__ + "Tinebase/js/ace-c9search-FAT.js";